/*
  List with image — sizes the decorative dashed connector so it spans exactly
  from each badge to the next, regardless of how tall the item descriptions are.
  Sets a per-badge `--connector-h` CSS variable consumed by the badge::after line.
  Only runs for lists with the connector enabled (`--connector` modifier).
*/
(() => {
  const BADGE = '.list-with-image__item-badge';
  const ITEM = '.list-with-image__item';

  const update = (list) => {
    const items = Array.from(list.querySelectorAll(ITEM));
    items.forEach((item, i) => {
      const badge = item.querySelector(BADGE);
      if (!badge) return;
      if (i === items.length - 1) {
        badge.style.removeProperty('--connector-h');
        return;
      }
      const nextBadge = items[i + 1].querySelector(BADGE);
      if (!nextBadge) return;
      const distance = nextBadge.getBoundingClientRect().top - badge.getBoundingClientRect().bottom;
      badge.style.setProperty('--connector-h', `${Math.max(distance, 0)}px`);
    });
  };

  const init = () => {
    const lists = document.querySelectorAll('.list-with-image__list--connector');
    lists.forEach((list) => {
      update(list);
      if (window.ResizeObserver) {
        new ResizeObserver(() => update(list)).observe(list);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
